<script setup lang="ts">
import { ModalHeaderType } from '@/features/excel-order-upload/types/modal-header.enums';
import { ButtonVariant } from '@/models/button-variant.enum';
import { Icons } from '@/models/icons.enum';
import { useI18n } from 'vue-i18n';
import BackstageButton from '../../../components/common/BackstageButton.vue';
import ModalContainer from './ModalContainer.vue';
import ModalHeader from './ModalHeader.vue';

interface Props {
  errorReason: string | null;
}

const emit = defineEmits<{
  close: [];
  backToUpload: [];
}>();

defineProps<Props>();
const { t } = useI18n();
</script>

<template>
  <ModalContainer @close="emit('close')">
    <template #header>
      <ModalHeader
        :title="t('excel_order_upload.upload_error_modal.title')"
        :description="t(`excel_order_upload.upload_error_modal.description.${errorReason ?? 'upload_template_error'}`)"
        :icon="Icons.FILLED_ERROR"
        :type="ModalHeaderType.ERROR" />
    </template>
    <template #footer>
      <BackstageButton :variant="ButtonVariant.SECONDARY" :full-width="true" @click="emit('close')">{{
        t('excel_order_upload.upload_error_modal.button_label.close')
      }}</BackstageButton>
      <BackstageButton :variant="ButtonVariant.PRIMARY" :full-width="true" @click="emit('backToUpload')">{{
        t('excel_order_upload.upload_error_modal.button_label.back_to_upload')
      }}</BackstageButton>
    </template>
  </ModalContainer>
</template>
